"use client";

import { AppPageTitle } from "@/widgets";
import HistorySection from "@/widgets/app/page/history/HistorySection";
import { SsgoiTransition } from "@ssgoi/react";

export default function HistoryPage() {
  return (
    <SsgoiTransition id="/app/pages/history">
      <div className="max-[991px]:pt-16 flex pt-24 w-full flex-col">
        <AppPageTitle />
      </div>

      <div className="w-full flex-col">
        <HistorySection />
      </div>
    </SsgoiTransition>
  );
}
